import Helper from './Helper';

class ChangeClassOnH1 {

  constructor(config = {}) {
    const {
      button,
      container
    } = config;

    this.button = document.querySelector(button);
    this.container = document.querySelector(container);
    if (this.button) {
        this.bindEvents();
    }
  }

  bindEvents() {
    this.button.addEventListener('click', ()=>this.changeClass(this.container));
  }

  changeClass(container) {
      if(Helper.hasClass(container, 'js-box-is-open')) {
        Helper.removeClass(container, 'js-box-is-open--animated');
        setTimeout(()=>{
          Helper.removeClass(container, 'js-box-is-open');
        }, 400);
      } else {
        Helper.addClass(container, 'js-box-is-open');
        setTimeout(()=>{
          Helper.addClass(container, 'js-box-is-open--animated');
        }, 200);
      }
  }
}

export default ChangeClassOnH1;
